export default {
  name: '',
  contactName: '',
  email: '',
  phone: '',
  billingAddress: '',
}
